import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelFaturas/fatContas/tabela.css'
import {
  desabilitarAcoes,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  mudarOrdenador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarDoppelgangerCliente,
  revelarExcluirConta
} from '../../../redux/actions/index'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import MensagemConfirmarExclusao from '../../componentesModais/mensagens/mensagemConfirmarExclusao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Table from '../../Table/index.jsx'

import DetalhamentoConta from './detalhamento/detalhamentoConta'
import NovaConta from './novaConta/novaConta'

const valorLimite = 50
let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0

const TableprimaryKey = 'cd_fat_conta'

function CadstroDeContas() {
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(0)
  const [cdConta, setCdConta] = useState(-1)
  const [empresaTitular, setEmpresaTitular] = useState()
  const [inicioCiclo, setInicioCiclo] = useState('')
  const [numeroConta, setNumeroConta] = useState()
  const [prazoPagamento, setPrazoPagamento] = useState()
  const [vencimento, setVencimento] = useState('')
  const [fornecedor, setFornecedor] = useState()
  const [operadora, setOperadora] = useState()
  const [mensagemErro, setMensagemErro] = useState('')
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState([])

  let itensVar = []
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let revelarNovaConta = useSelector(
    (state) => state.faturasState.revelarNovaConta
  )
  let revelarEditarConta = useSelector(
    (state) => state.faturasState.revelarEditarConta
  )
  let excluirConta = useSelector(
    (state) => state.faturasState.revelarExcluirConta
  )
  let ordenador = useSelector((state) => state.manejadorState.ordenador)

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let estadoExpansaoMenu = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  const [spinAtivo, setSpinAtivo] = useState(true)

  const despacho = useDispatch()
  const cd_pav_usuario = decryptJWT('codigo')

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(620) // 'fatContasTabela'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('fatConta'))
    despacho(desabilitarAcoes(true))

    async function carregarTabela() {
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (ordenador) {
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const queryString =
            'paginaAtual=' +
            contador +
            '&carregarLimit=' +
            valorLimite +
            '&buscar=' +
            conteudoBusca +
            '&ordenador=' +
            ordenador +
            '&cd_pav_usuario=' +
            cd_pav_usuario
          const { data } = await api_gateway.get(
            '/m1/consultar/fat_conta?' + queryString
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          filtros: filtros,
          ordenador: ordenador,
          cd_pav_usuario: cd_pav_usuario
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/fat_conta',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const queryString =
            'paginaAtual=' +
            contador +
            '&carregarLimit=' +
            valorLimite +
            '&ordenador=' +
            ordenador +
            '&cd_pav_usuario=' +
            cd_pav_usuario
          const { data } = await api_gateway.get(
            '/m1/consultar/fat_conta?' + queryString
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
    contarItens()
  }, [paginaAtual, conteudoBusca, ordenador, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && filtros.vazio) {
      apiData = await api_gateway.get(
        '/m1/consultar/fat_conta?contar="true"&buscar=' +
          conteudoBusca +
          '&ordenador=' +
          ordenador +
          '&cd_pav_usuario=' +
          cd_pav_usuario
      )
    } else {
      const dados = {
        paginaAtual: contador,
        carregarLimit: valorLimite,
        buscar: conteudoBusca,
        filtros: filtros,
        ordenador: ordenador,
        contar: true,
        cd_pav_usuario: cd_pav_usuario
      }
      apiData = await api_gateway.post('/m1/filtrar/fat_conta', dados)
    }
    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  async function handleDeletar() {
    setSpinAtivo(true)
    await api_gateway
      .get('/m1/deletar/fat_conta?cd_fat_conta=' + cdConta)
      .then(function (response) {
        if (response.data.status === 600) {
          setMensagemErro(response.data.info)
          despacho(revelarExcluirConta(false))
          handleMensagemErro(false)
          setSpinAtivo(false)
        } else {
          setRenderizar(!renderizar)
          despacho(revelarExcluirConta(false))
          handleMensagemSucesso(false)
          setSpinAtivo(false)
        }
      })
      .catch(function () {
        setMensagemErro('Erro ao excluir conta!')
        despacho(revelarExcluirConta(false))
        handleMensagemErro(false)
        setSpinAtivo(false)
      })
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      despacho(revelarExcluirConta(false))
      if (confirmacao === true) {
        ColetaClickstream(1284)
        handleDeletar()
      } else {
        ColetaClickstream(1285)
      }
    }
  }

  const colunas = [
    {
      dataField: 'ds_conta',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('ds_conta', 'ds_conta')}
        >
          Número da conta
          <Image
            id="ds_contads_conta"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined ? cell : -1}
          </p>
        )
      }
    },
    {
      dataField: 'n0_dia_inicial_ciclo',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() =>
            handlerOrdenador('n0_dia_inicial_ciclo', 'n0_dia_inicial_ciclo')
          }
        >
          Inicio do ciclo
          <Image
            id="n0_dia_inicial_ciclon0_dia_inicial_ciclo"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined
              ? 'Dia ' + cell
              : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'n0_dia_vencimento',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() =>
            handlerOrdenador('n0_dia_vencimento', 'n0_dia_vencimento')
          }
        >
          Vencimento
          <Image
            id="n0_dia_vencimenton0_dia_vencimento"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined
              ? 'Dia ' + cell
              : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'n0_meses_sequentes',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() =>
            handlerOrdenador('n0_meses_sequentes', 'n0_meses_sequentes')
          }
        >
          Prazo de pagamento
          <Image
            id="n0_meses_sequentesn0_meses_sequentes"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell == '' || cell == null || cell == undefined
              ? '-'
              : cell + ' mês (es)'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_apelido',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('ds_apelido', 'ds_apelido')}
        >
          Operadora
          <Image
            id="ds_apelidods_apelido"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell == '' || cell == null || cell == undefined ? '-' : cell}
          </p>
        )
      }
    },
    {
      dataField: 'ds_nome_fantasia',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() =>
            handlerOrdenador('ds_nome_fantasia', 'ds_nome_fantasia')
          }
        >
          Empresa titular
          <Image
            id="ds_nome_fantasiads_nome_fantasia"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell == '' || cell == null || cell == undefined ? '-' : cell}
          </p>
        )
      }
    },
    {
      dataField: 'n0_simcards',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('n0_simcards', 'n0_simcards')}
        >
          SIM cards cadastrados
          <Image
            id="n0_simcardsn0_simcards"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined ? cell : '-'}
          </p>
        )
      }
    }
  ]

  function handlerDesativarImagens(imagem, terminacao) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )

    imagem.classList.remove('d-none')
    imagem.classList.add('icone-ordenacao-' + terminacao)
  }

  function handleRemoverImagens(imagem) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    imagem.classList.remove('icone-ordenacao-ASC')
    imagem.classList.remove('icone-ordenacao-DESC')
  }

  async function handlerOrdenador(nomeOrdenador, nomeDiferenciado) {
    let isItDescrescente = false
    const imagem = document.getElementById(nomeOrdenador + nomeDiferenciado)

    if (
      nomeOrdenador === ordenador.split(' ASC')[0] ||
      nomeOrdenador === ordenador.split(' DESC')[0]
    ) {
      await ordenador.split(' ').map((item_ordenador) => {
        if (item_ordenador === 'ASC') {
          ordenador = nomeOrdenador + ' DESC'
          isItDescrescente = true

          handlerDesativarImagens(imagem, 'ASC')
        }
        if (item_ordenador === 'DESC') {
          ordenador = ''
          isItDescrescente = false

          handleRemoverImagens(imagem)
        }
      })
    } else if (!isItDescrescente) {
      ordenador = nomeOrdenador + ' ASC'

      handlerDesativarImagens(imagem, 'DESC')
    }
    despacho(mudarOrdenador(JSON.parse(JSON.stringify(ordenador))))
  }

  function handleSelecionarConta(
    codigo,
    numeroConta,
    empresa_titular,
    inicio_ciclo,
    prazo_pagamento,
    vencimento,
    fornecedor,
    operadora
  ) {
    setCdConta(codigo)
    setNumeroConta(numeroConta)
    setEmpresaTitular(empresa_titular)
    setInicioCiclo(inicio_ciclo)

    setPrazoPagamento(prazo_pagamento)

    setVencimento(vencimento)
    setFornecedor(fornecedor)
    setOperadora(operadora)
    despacho(desabilitarAcoes(false))
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    despacho(desabilitarAcoes(true))
    setPaginaAtual(1)
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      despacho(revelarDoppelgangerCliente(false))
      if (confirmacao === true) {
        setRenderizar(!renderizar)
      }
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <div
        className={
          estadoExpansaoMenu === true
            ? 'expand-row-fat-contas-1'
            : 'expand-row-fat-contas-2'
        }
      >
        <DetalhamentoConta cd_fat_conta={row.cd_fat_conta} />
      </div>
    )
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)
      handleSelecionarConta(
        row.cd_fat_conta,
        row.ds_conta,
        row.ds_nome_fantasia,
        row.n0_dia_inicial_ciclo,
        row.n0_meses_sequentes,
        row.n0_dia_vencimento,
        row.ds_fat_fornecedor,
        row.ds_apelido
      )
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        permissaoDetalhamentoLinha
        revelarBarraFiltro={revelarBarraFiltro}
        detalhamentLinha={renderDetalhamentoLinha}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1={'A conta ' + numeroConta + ' foi excluído.'}
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Ocorreu um erro. Tente novamente mais tarde."
              mensagemParagrafo2="Caso o erro persista, entre em contato com o Suporte."
              mensagemParagrafo3={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarNovaConta === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovaConta
              tituloJanela="Cadastrar"
              setRenderizar={setRenderizar}
              renderizar={renderizar}
            />
          </div>
        </div>
      )}
      {revelarEditarConta === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovaConta
              tituloJanela="Editar"
              setRenderizar={setRenderizar}
              renderizar={renderizar}
              cdConta={cdConta}
              numeroConta={numeroConta}
              inicioCiclo={inicioCiclo}
              dsFornecedor={fornecedor}
              dsEmpresa={empresaTitular}
              dsOperadora={operadora}
              vencimento={vencimento}
              prazoPagamento={prazoPagamento}
            />
          </div>
        </div>
      )}
      {excluirConta === true && (
        <MensagemConfirmarExclusao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={'Deletar ' + numeroConta}
        />
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

export default connect(mapStateToProps)(React.memo(CadstroDeContas))
